export default __webpack_public_path__ + "static/media/hero_image.01ea9023.png";